import clsx from 'clsx'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { IconPaths } from '_metronic/helpers/enumsUI'
import { useT } from '_metronic/i18n/Metronici18n'
import { Button } from 'app/components/Button/Button'
import { ID_MINI_PLAYER, rotaDaChamada } from '../core/_models'
import { REGRAS_MINI_PLAYER, REGRAS_RESERVA_MINI_PLAYER } from '../core/regrasDoPlayer'

type Props = {
  atendimentoId: number | null
  visivel: boolean
  /** Callback ref estável do container do vídeo (o host move o nó para cá). */
  registrar: (el: HTMLDivElement | null) => void
}

/**
 * Reserva quando o Document PiP não está disponível (Firefox/Safari) ou foi recusado (gesto expirado).
 * O vídeo não responde a clique; a barra "Voltar ao atendimento" é o único elemento clicável.
 */
export const MiniPlayer: FC<Props> = ({ atendimentoId, visivel, registrar }) => {
  const navigate = useNavigate()
  const { t } = useT()

  const voltar = () => {
    if (atendimentoId !== null) navigate(rotaDaChamada(atendimentoId))
  }

  return (
    <>
      <div
        id={ID_MINI_PLAYER}
        role='region'
        aria-label={t('atendimento.chamada.mini_player')}
        className={clsx(
          'position-fixed bottom-0 end-0 m-3 m-md-5 w-150px w-md-300px rounded overflow-hidden shadow bg-black z-index-3',
          !visivel && 'd-none'
        )}
      >
        <style>{REGRAS_MINI_PLAYER}</style>
        <Button
          className='btn-secondary w-100 rounded-0'
          size='btn-sm'
          icon={IconPaths.ArrowLeft}
          onClick={voltar}
        >
          {t('atendimento.chamada.voltar')}
        </Button>
        {/* `position-relative`: o player (neutralizado para `position: absolute`) se contém aqui e não cobre a barra. */}
        <div ref={registrar} className='position-relative h-100px h-md-175px pe-none' />
      </div>
      {visivel && <style>{REGRAS_RESERVA_MINI_PLAYER}</style>}
    </>
  )
}
